import { GDSSpace, useTheme } from '@leagueplatform/genesis-core';

// Util function to slice the 'px' from a string value 😅
export const slicePx = (value: string) => Number(value.slice(0, -2));

/**
  @params spaceBetweenCards: GDSSpace
  @returns number
  @description: This function converts a GDSSpace Token to px
  @default: 16
  @example: useGenesisSpaceTokenInPx('$one') -> 16
*/
export const useGenesisSpaceTokenInPx = (spaceBetweenCards: GDSSpace) => {
  const { space } = useTheme();
  const token = space[spaceBetweenCards.slice(1)];

  if (token) {
    const tokenValue = token.value;
    return slicePx(tokenValue);
  }

  return 16;
};

/**
@params element: HTMLElement
@returns { top: number, left: number, bottom: number, right: number }
@description: This function returns the position of an element relative to its parent. The return value is an object containing the positional values of the elements rect relative to its parent
*/
export function getPositionRelativeToParent(element: HTMLElement) {
  const parent = element.parentElement;
  const parentRect = parent?.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  if (parentRect) {
    return {
      top: elementRect.top - parentRect.top,
      left: elementRect.left - parentRect.left,
      bottom: elementRect.bottom - parentRect.top,
      right: elementRect.right - parentRect.left,
    };
  }

  return {
    top: elementRect.top,
    left: elementRect.left,
    bottom: elementRect.bottom,
    right: elementRect.right,
  };
}

/**
 *
 * @param {Function} func
 * @param {number} wait
 * @returns void
 * @description: This function debounces the resize observer event - debounce from lodash wasnt working -_-
 */
export const resizeObserverDebounce = (func: Function, wait: number) => {
  let timeout: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
